import escapeRegExp from "lodash/escapeRegExp";

export const RESERVED_SUBDOMAINS = [
  "sso",
  "academy",
  "api",
  "auth",
  "builder",
  "cdn",
  "contact",
  "data",
  "docs",
  "embed",
  "help",
  "ingest",
  "james",
  "learn",
  "links",
  "mail",
  "mbmail",
  "n8n",
  "out",
  "pages",
  "podcast",
  "service",
  "staging",
  "status",
  "test",
  "trail",
  "transform",
  "vitality-lab",
  "web",
  "www",
];

export const DOMAIN_VALIDATION_REGEX = {
  SUBDOMAIN_SHORT: /^[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/,
  SUBDOMAIN_FULL_STR: (topDomain = "") =>
    `^[a-z0-9][a-z0-9-]{0,61}[a-z0-9]\\.${escapeRegExp(topDomain)}$`,
  CUSTOM_DOMAIN: /^(?!-)[a-z0-9-]{1,63}(?<!-)(\.[a-z]{2,})+$/,
};
